export class User {
  userId!: number;

  fullName!: string;
  loginId!: string;

  email!: string;
  phone!: number;

  roleId!: number;
  roleName!: string;

  deptId!: number;
  deptName!: string;

  isActive!: boolean;

  constructor(init?: Partial<User>) {
    Object.assign(this, init);
  }
}